<template>
    <div
        class="list-group-item list-group-item-action cursor-pointer"
        :style="isActive ? $bgColor(color.primary) : '' "
        :class="isActive"
        @click="lessonInfo">
        <div class="d-flex align-items-center" :style="isActive ? [$bgColor(color.primary), { color: color.secondary }] : '' ">
            <span v-if="content.lock">
                <i :class="changeIcon"></i>
            </span>
            <span v-else-if="content.completed">
                <i class="mdi mdi-checkbox-marked mr-2"></i>
            </span>
            <span v-else>
                <i class="mdi mdi-checkbox-blank-outline mr-2"></i>
            </span>
            <h6 class="side-bar-text font-weight-bold mb-0" :style="isActive ? [$bgColor(color.primary), { color: color.secondary }] : '' ">{{contentName}}
            </h6>
        </div>
        <div class="text-muted side-bar-text">
            <span v-if="content.has_block"><i class="mdi mdi-lock"></i></span>
            <span v-if="content.time_video">{{$t('common.duration')}}: {{calcTime(content.time_video)}} </span>
            <span v-if="isLive"><i class="mdi mdi-circle pr-1"></i>{{$t('content.type.live')}}</span>
            <span v-if="content.type_upload"><i class="mdi mdi-file pr-1"></i>{{$t('content.type.file')}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LessonListContent',
    props: {
        content: {
            type: Object,
            required: true
        },
        selectContentId: {
            type: Number || null
        }
    },
    data() {
        return {
            loadedCertificate: null,
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        isActive() {
            if (this.content.id === this.selectContentId) return 'active'
        },
        contentName() {
            if (this.content.translation.name) return this.content.translation.name
            return this.$t('content.download_content')
        },
        isLive() {
            return this.content.type_video == 'LV' || this.content.type_video == 'LVW'
        },
        formatedStartDate() {
            const startDate = new Date(this.content.exercise_publish.start_date);

            const formattedDate = startDate.toISOString().split('T')[0];

            const formattedTime = startDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedDateTimeWithSuffix = `${formattedDate} ${translation} ${formattedTime}`;

            return formattedDateTimeWithSuffix;
        },
        formatedEndDate() {
            const endDate = new Date(this.content.exercise_publish.end_date);

            const formattedEndDate = endDate.toISOString().split('T')[0];

            const formattedEndTime = endDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedEndDateTimeWithSuffix = `${formattedEndDate} ${translation} ${formattedEndTime}`;

            return formattedEndDateTimeWithSuffix;
        },
        changeIcon() {
            if (this.content.lock_type === 'SCHEDULE') {
                const currentDate = new Date().toISOString().split('T')[0];

                if (this.content.exercise_publish.start_date > currentDate) {
                    return 'mdi mdi-calendar-clock';
                } else if (this.content.exercise_publish.end_date < currentDate) {
                    return 'mdi mdi-calendar-check';
                }
            } else {
                return 'mdi mdi-lock-outline';
            }
        },
    },
    methods: {
        showBlockedAlert() {
            if (this.content.lock_type === 'SCHEDULE') {
                if (this.content.exercise_publish && new Date(this.content.exercise_publish.start_date) > new Date()) {
                    return this.$notify({
                        type: "warning",
                        message: `${this.$t('exercise.publish.schedule')} ${this.formatedStartDate} ${this.$t('common.and')} ${this.formatedEndDate}`,
                    });
                } else if (this.content.exercise_publish && new Date(this.content.exercise_publish.end_date) < new Date() && this.content.exercise_publish.end_date !== null) {
                    if (this.content.exercise_grades === null) {
                        return this.$notify({
                            type: "warning",
                            message: `${this.$t('exercise.publish.schedule_end')} ${this.formatedEndDate}`,
                        });
                    }
                    return this.$notify({
                        type: "warning",
                        message: `${this.$t('exercise.publish.schedule_end')} ${this.formatedEndDate}<br>${this.$t('common.final_grade')} ${this.content.exercise_grades}`,
                    });
                }
            }

            if (this.content.lock_type === 'AVAILABLE') {
                return '';
            }

            if (this.content.exercise_publish && this.content.exercise_publish.start_date === null && this.content.exercise_publish.end_date === null && this.content.lock_type !== 'AVAILABLE') {
                return this.$notify({
                    type: "warning",
                    message: this.$t('common.blocked'),
                });
            }

            // Caso não seja nenhum dos casos anteriores, verifica se o conteúdo está disponível
            if (this.content.lock_type !== 'AVAILABLE') {
                return this.$notify({
                    type: "warning",
                    message: this.$t('common.blocked'),
                });
            }
        },
        lessonInfo() {
            this.showBlockedAlert();
            if(!this.content.lock) {
                this.$emit('contentClicked', this.content)
            }
        },
        calcTime(time) {
            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = ~~time % 60;

            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        }
    },
    async beforeMount() {
        if (this.content.exercise_publish !== undefined) {
            this.loadedCertificate = await this.$store.dispatch(
                'GET_EXERCISE_CERTIFICATE',
                this.content.exercise_publish.exercise_id
            );
        }
    }
}
</script>

<style>
.side-bar-text {
    font-size: 0.8rem
}

.cursor-pointer {
    cursor: pointer;
}

.sidebar-content {
    transition: all 0.3s;
    overflow-x: hidden;
    overflow-y: auto;
    position: sticky;
    z-index: 1;
    right: 0;
}

.sidebar-content.header-not-fixed {
    top: 0;
}

.sidebar-content.header-fixed {
    top: 95px;
}

.list-group-item:first-child {
    border-top-left-radius: 0rem;
    border-top-right-radius: 0rem;
}

.list-group-item:last-child {
    border-bottom-left-radius: 0rem;
    border-bottom-right-radius: 0rem;
}
</style>
